<lib-stores
  [labels]="'lib.stores' | translate"
  [theme]="theme"
  [imgText]="'homePage.stores.imgText' | translate"
  [storesImg]="imageSrc"
  [locations]="locations"
></lib-stores>
